import React from 'react'
import { Stack, Typography } from '@mui/material'

import { BEIGE_400, BEIGE_600, GRAY_700, GRAY_900, WHITE } from 'constants/styling/theme'

interface Props {
  title: string
  subtitle?: string
  /** The last section fills the rest of the drawer in beige; the others stay white. */
  isLast?: boolean
  /** A line above, separating it from the white section it follows. */
  divided?: boolean
  gap?: number
  /** Drop the panel chrome, for a host that already owns its spacing. */
  plain?: boolean
  children: React.ReactNode
}

/** One titled panel of the product drawer's scroll area. */
export const DrawerSection: React.FC<Props> = ({ title, subtitle, isLast = false, divided = false, gap = 2.4, plain = false, children }) => (
  <Stack
    gap={gap}
    sx={plain ? undefined : {
      backgroundColor: isLast ? BEIGE_400 : WHITE,
      borderTop: divided ? `1px solid ${BEIGE_600}` : undefined,
      p: 2.4,
      flex: isLast ? 1 : undefined,
    }}
  >

    <Stack gap={0.4}>

      <Typography variant="text-lg" fontWeight={550} color={GRAY_900}>
        {title}
      </Typography>

      {subtitle &&
        <Typography variant="text-md" fontWeight={450} color={GRAY_700}>
          {subtitle}
        </Typography>
      }

    </Stack>

    {children}

  </Stack>
)
